import Image from '../../assets/ApplyJob.svg'
import { useNavigate } from 'react-router-dom';
import { IoCloseOutline } from "react-icons/io5";

export const JobApplyPopup = ({setPopup}) => {
    const navigate = useNavigate()

       const handleProceed = (id) => {
          setPopup(false)
          if(id === "login"){
              navigate('/login')
          }
          else if(id === "register"){
              navigate('/signup')
          }
       }

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] px-4">

            {/* Popup box */}
            <div className="relative bg-white w-full max-w-md rounded-xl shadow-xl p-6 animate-[fadeIn_0.3s_ease]">

                {/* Close Button */}
                <button
                    onClick={() => setPopup(false)}
                    className="absolute top-3 right-3  flex items-center justify-center  text-gray-400 rounded-full"
                >
                    <IoCloseOutline  size={24}/>
                </button>

                {/* Title */}
                <h2 className="text-[24px] font-semibold text-gray-800 mt-4 mb-2 text-center">
                    Wait! You’re not logged in
                </h2>

                {/* Image */}
                <img src={Image} alt="apply job" className="mx-auto my-4" />

                {/* Message */}
                <div>
                    <p className="text-center text-gray-600 font-semibold  px-2">
                        You need an account to save or apply for jobs.
                    </p>
                    <p className="text-center text-gray-600  mb-6 px-2">It takes less than 30 seconds!</p>
                </div>

                {/* Buttons */}
                <div className="flex items-center justify-center gap-4 font-semibold">

                    <button onClick={() => handleProceed('register')}
                        className="px-5 py-2 rounded-lg border border-primary-400 text-primary-400 transition"
                    >
                        Sign Up
                    </button>

                    <button onClick={() => handleProceed('login')}
                        className="px-5 py-2 rounded-lg bg-primary-400 text-white hover:bg-primary-500 transition"
                    >
                        Log In
                    </button>

                </div>
            </div>
        </div>
    );
};
